import React from 'react';
import clsx from 'clsx';
import styles from './ListItem.module.scss';

type OwnProps = {
  text: string;
  itemKey?: string;
  isSelected?: boolean;
  onClickHandler?: () => void;
  icon?: string;
};

export const ListItem = (props: OwnProps) => {
  const { onClickHandler, isSelected, itemKey, icon, text } = props;

  const onClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
    onClickHandler?.();
  };

  return (
    <div
      data-test-id={'language-item-' + itemKey}
      key={itemKey}
      onClick={(e) => onClick(e)}
      className={clsx(
        styles.item,
        styles.rowContainer,
        icon && styles.columnGap,
        isSelected && styles.selectedOption,
      )}
    >
      <img src={icon} />
      <div>{text}</div>
    </div>
  );
};
